module.exports = __webpack_public_path__ + "static/unnamed-6--0bb245cfa189cc613188e9f3f5c84388.png";